<!-- 自定义列设置弹窗 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <div v-for="item in columnData" :key="item.ColumnCode" class="set-item">
                <el-checkbox :disabled="!item.IsCanSet" :checked="item.IsShow" v-model="item.IsShow" border class="item-canset"></el-checkbox>
                <el-input v-model="item.ColumnName" :disabled="item.ColumnName == '操作'" class="item-cname"></el-input>
                <el-input v-model="item.Width" :disabled="item.ColumnName == '操作'" class="item-width">
                    <template popper-class="item-width-title" slot="prepend">宽度</template>
                    <template popper-class="item-width-title" slot="append">PX</template>
                </el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
            <el-button class="search-btn" size="small" type="danger" @click="clearCache">清除缓存</el-button>
            <el-button class="search-btn" size="small" type="warning" @click="restoreDefault">恢复默认</el-button>
            <el-button class="search-btn" size="small" @click="closeDialog(false)">取消</el-button>
            <el-button class="search-btn btn-primary" size="small" @click="submit">保存设置</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['tableCode'],
    components: {},
    data() {
        return {
            columnData: {},
            loading: false
        };
    },
    mounted() {
        this.getSetsData();
    },
    methods: {
        getSetsData() {
            this.loading = true;
            this.$util
                .getTableSetsData(this.tableCode)
                .then(data => {
                    this.columnData = data;
                    this.loading = false;
                })
                .catch(res => {
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        submit() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/SubmitStaffTableSets',
                    data: { TableCode: this.tableCode, ColumnData: this.columnData },
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$util.clearLocalStorage('ts_' + this.tableCode);
                    this.closeDialog(true);
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        restoreDefault() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: `/api/EntpInfoManagement/RestoreDefaultTableSets?tableCode=${this.tableCode}`,
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$util.clearLocalStorage('ts_' + this.tableCode);
                    this.closeDialog(true);
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog(isEdit) {
            this.$util.clearLocalStorage('ts_temp_' + this.tableCode);
            this.$emit('closeDialog', isEdit);
        },
        clearCache() {
            this.$util.clearLocalStorage('ts_temp_' + this.tableCode);
            this.$util.clearLocalStorage('ts_' + this.tableCode);
            this.getSetsData();
        }
    }
};
</script>
<style lang="less" scoped>
.set-content {
    display: flex;
    flex-direction: column;

    .set-item {
        display: flex;
        flex-direction: row;

        .item-canset {
            width: 7%;
            border-radius: 5px 0 0 5px;
        }

        .item-cname {
            width: 63%;
        }

        .item-width {
            width: 40%;
        }
    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-input__inner {
        border-radius: 0;
    }
}
</style>
